import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock } from 'lucide-react';

const services = [
  { icon: '🧾', title: 'Individual Tax Return', duration: '30 min' },
  { icon: '🏠', title: 'Couple Tax Return', duration: '30 min' },
  { icon: '📊', title: 'Individual Tax Return + Rental Properties', duration: '30 min' },
  { icon: '🚗', title: 'Uber — Business Activity Statement', duration: '30 min' },
  { icon: '🏢', title: 'Company Quarterly BAS', duration: '30 min' },
  { icon: '🤝', title: 'Company Tax Return', duration: '30 min' },
  { icon: '📋', title: 'Trust Tax Return', duration: '30 min' },
  { icon: '💼', title: 'Company Creation', duration: '30 min' },
  { icon: '👨‍👩‍👧', title: 'Business Consultation', duration: '30 min' },
];

const shortDesc = 'Professional accounting support tailored to your needs.';

export default function ServicesGrid() {
  return (
    <>
      <style>{`
        .svc-section { background: var(--off-white); padding: 96px 0; }
        .svc-header { text-align: center; max-width: 660px; margin: 0 auto 60px; }
        .svc-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 22px;
        }
        .svc-card {
          background: var(--white);
          padding: 32px 28px;
          position: relative; overflow: hidden;
          transition: all 0.28s ease;
          display: flex; flex-direction: column;
          border: 1px solid var(--border);
          border-radius: var(--radius);
          box-shadow: var(--shadow-sm);
        }
        .svc-card:hover { box-shadow: var(--shadow-lg); transform: translateY(-6px); border-color: var(--gold); }
        .svc-card::after {
          content: ''; position: absolute;
          top: 0; left: 0; right: 0; height: 3px;
          background: var(--gold); transform: scaleX(0);
          transform-origin: left; transition: transform 0.3s ease;
        }
        .svc-card:hover::after { transform: scaleX(1); }
        .svc-top { display: flex; align-items: center; justify-content: space-between; margin-bottom: 18px; }
        .svc-icon-wrap {
          width: 54px; height: 54px;
          background: var(--gold-bg); border: 1px solid rgba(201,168,76,0.25);
          border-radius: var(--radius-sm);
          display: flex; align-items: center; justify-content: center;
          font-size: 24px;
        }
        .svc-duration {
          display: inline-flex; align-items: center; gap: 5px;
          font-size: 11px; font-weight: 600; color: var(--text-light);
          background: var(--grey-100); border: 1px solid var(--border);
          border-radius: var(--radius-sm); padding: 5px 10px;
        }
        .svc-duration svg { color: var(--gold); }
        .svc-title {
          font-family: var(--font-display);
          font-size: 17px; font-weight: 600;
          color: var(--text-dark); margin-bottom: 10px; line-height: 1.3;
        }
        .svc-short {
          font-size: 13px; font-weight: 300; line-height: 1.75;
          color: var(--text-light); margin-bottom: 0;
        }
        .svc-more {
          margin-top: 48px; text-align: center;
        }
        @media (max-width: 900px) { .svc-grid { grid-template-columns: repeat(2,1fr); } }
        @media (max-width: 560px) { .svc-grid { grid-template-columns: 1fr; } }
      `}</style>

      <section className="svc-section">
        <div className="container">
          <div className="svc-header">
            <span className="section-eyebrow">What We Do</span>
            <h2 className="section-title">These Are <em>Our Services</em></h2>
            <p className="section-body" style={{margin:'0 auto'}}>
              Professionally qualified and experienced people — we deliver the best possible
              outcome for all your tax and accounting obligations.
            </p>
          </div>

          <div className="svc-grid">
            {services.map(({ icon, title, duration }) => (
              <div key={title} className="svc-card">
                <div className="svc-top">
                  <div className="svc-icon-wrap">{icon}</div>
                  <div className="svc-duration"><Clock size={12} />{duration}</div>
                </div>
                <div className="svc-title">{title}</div>
                <div className="svc-short">{shortDesc}</div>
              </div>
            ))}
          </div>

          <div className="svc-more">
            <Link to="/services" className="btn-dark">
              View All Services <ArrowRight size={15} />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
